import { SuiGrpcClient } from "@mysten/sui/grpc";
import { fromBase64 } from "@mysten/sui/utils";

// Sui gRPC through our same-origin gRPC-web bridge (the gRPC node itself can't be reached from browsers).
export const GRPC_URL = `${process.env.REACT_APP_BACKEND_URL}/api/sui-grpc`;

export function createSuiClient() {
  const client = new SuiGrpcClient({ network: "mainnet", baseUrl: GRPC_URL });
  // dapp-kit's useSignAndExecuteTransaction executes via this method name.
  client.executeTransactionBlock = async ({ transactionBlock, signature }) => {
    const bytes = typeof transactionBlock === "string" ? fromBase64(transactionBlock) : transactionBlock;
    const r = await client.core.executeTransaction({
      transaction: bytes, signatures: Array.isArray(signature) ? signature : [signature], include: { effects: true },
    });
    if (r.FailedTransaction) throw new Error(r.FailedTransaction.status?.error?.message || "Transaction failed on-chain");
    return { digest: r.Transaction.digest, rawEffects: Array.from(r.Transaction.effects?.bcs || []) };
  };
  return client;
}
